export const CUSTOMER_ENUM = {
  CRED: "Cred",
  BIG_BASKET: "Big Basket",
  BOOKMYSHOW: "BookMyShow",
  LENSKART: "Lenskart",
  NYKAA: "Nykaa",
  WELTBILD: "Weltbild",
  DUBREUIL : "Dubreuil",
  CURTSY: "Curtsy",
  LEROY: "Leroy",
  DUNZO: "Dunzo",
  UPGRAD: "Upgrad",
  ZEPTO: "Zepto",
  EIGHT_X_EIGHT: "8x8",
  JAMIE_OLIVER: "Jamie Oliver",
  MOENGAGE: "Moengage",
  HOPSCOTCH: "Hopscotch",
  KOO: "Koo",
  NINETY_ONE_MOBILE: "91Mobiles",
  CARS_CO_ZA: "Cars.co.za",
  TRAVELOKA: "Traveloka",
  SINTRA_CONSULTING: "Sintra Consulting",
  PURPLLE_COM: "Purplle.com",
  THE_LOOM: "The Loom",
  ZIVAME: "Zivame",
  JAYPORE: "Jaypore",
  VENTIS: "Ventis",
  UTSAV_FASHION: "Utsav Fashion",
  MIAMI: "MIAMI",
  SPINE_MEDIA: "Spine Media",
  DURIAN: "Durian",
  SONY: "Sony",
  STANDARD_NEWS: "Standard News",
  HYRECAR: "HyreCar",
  ASIAN_PAINTS: "Asian Paints",
  SWIGGY: "Swiggy",
  KREDITBEE : "KreditBee",
  SAFFRON_STAYS : "Saffron Stays",
  APPSTEM : "Appstem",
  ETREX : "Etrex",
  SECRETLAB : "SecretLab",
  CROMA : "Croma",
  STAMPED : "Stamped",
  AUCIO : "Aucio",
  SEVENTYTWO : "SeventyTwo",
  LIMELY : "Limley",
  FOCALWORKS : "Focalworks",
  APOLLO247: "Apollo 24|7"
};

export const customerList = [
  {
    name: CUSTOMER_ENUM.SWIGGY,
    logo: 'https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Swiggy_logo.svg?updatedAt=1713502133643',
    whiteLogo : 'https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Swiggy.svg?updatedAt=1714488684778',
    caseStudy: {
      link:
        "https://imagekit.io/blog/swiggy-imagekit-case-study/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/SwiggyGraphic@3x.webp?updatedAt=1714491389556&tr=w-600",
      excerpt:
        "Swiggy enhanced performance, personalized UX, and saved costs across platforms.",
      highlight: "Better performance & UX with cost savings",
    },
    testimonials: [
      {
        text:
          "Having access to individual sub-accounts for each business unit has been a game-changer. It allows our teams to try out new ideas quickly and keep track of how our media is performing. If there’s a problem with optimization in any business unit, we can address it promptly.",
        author: "Farhan Rasheed",
        authorTitle: "Engineering Manager, Swiggy",
        authorPic:
          "https://ik.imagekit.io/ikmedia/farhan_profile_pic.jpeg?tr=w-80",
      },
    ]
  },
  {
    name: CUSTOMER_ENUM.CRED,
    lightenLogo: true,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Cred_120_45_smnVWQmxd.png",
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/CRED_HfLE6zsNZ.png",
  },
  {
    name: CUSTOMER_ENUM.SAFFRON_STAYS,
    lightenLogo: true,
    logo: 'https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/saffron_stays.png?updatedAt=1734883356293',
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/SaffronStays.svg?updatedAt=1719377072692",
    caseStudy: {
      link:
        "https://imagekit.io/blog/helping-both-top-and-bottom-line-saffronstays-rapid-profitable-growth-with-imagekit/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/SaffronStaysCover@3x.jpg?updatedAt=1719377313405&tr=w-600",
      excerpt:
        "Top-notch visual experiences with enhanced operational efficiency",
      highlight: "Top-notch visual experiences with enhanced operational efficiency",
      type: "video"
    },
    testimonials: [
      {
        text:
          "A beautiful thing ImageKit did was crack the code to deliver a seamless migration. Migrating from the previous third party to ImageKit was merely a day's process. ImageKit helped us migrate without having to move our storage or shut down the old CDN.",
        author: "Sarang Purandare",
        authorTitle: "CTO, SaffronStays",
        authorPic:
          "https://ik.imagekit.io/ikmedia/sarang_purandare_saffronstays.png?tr=w-80",
      },
    ]
  },
  {
    name: CUSTOMER_ENUM.KREDITBEE,
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/KreditBee.svg?updatedAt=1719376306964",
    hideLogo: true,
    caseStudy: {
      link:
        "https://imagekit.io/blog/how-kreditbee-simplified-media-experiences-with-imagekit/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/KreditBeeCover@3x.jpg?updatedAt=1719377313400&tr=w-600",
      excerpt:
        "Simplified media delivery for improved user experience",
      highlight: "Simplified media delivery for improved user experience"
    }
  },
  {
    name: CUSTOMER_ENUM.APOLLO247,
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/apollo247.svg",
    hideLogo: true,
    caseStudy: {
      link:
        "https://imagekit.io/blog/apollo247-imagekit-case-study/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/Graphics/Apollo%20case%20study/apollo%20banner.jpg?updatedAt=1734589599554&tr=w-600",
      excerpt:
        "Faster load time at 50% lower cost",
      highlight: "Faster load time at 50% lower cost"
    }
  },
  {
    name: CUSTOMER_ENUM.BIG_BASKET,
    logo: "https://ik.imgkit.net/ikmedia/big-basket-logo_61DxaCJHw.png",
    whiteLogo : "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/big%20basket@3x.webp?updatedAt=1714490988927",
    hideLogo: true,
    circularLogo:
      "https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/big-basket_dSP9GjNmR.png",
    caseStudy: {
      link:
        "https://imagekit.io/blog/bigbasket-optimized-bandwidth-improved-experience-imagekit/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/BBGraphic@3x.webp?updatedAt=1714491389724",
      excerpt:
        "BigBasket optimized bandwidth consumption by 25% to improve its customer experience.",
      highlight: "Optimized bandwidth consumption by 25%",
    },
    testimonials: [
      {
        text:
          "Effortlessly switched from our in-house image resizing solution to ImageKit. It helped make our web pages load faster on different devices and simplified our image workflow. It helped also us reduce our infrastructure costs!",
        author: "Rupesh Kumar",
        authorTitle: "Director of Engineering, BigBasket",
        authorPic:
          "https://ik.imgkit.net/ikmedia/rupesh-kumar_NvSK2grvp.png?tr=w-80",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.BOOKMYSHOW,
    logo: "https://ik.imagekit.io/ikmedia/website-2024/customers/bookmyshow.svg?updatedAt=1710245762904",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/bmslogo.svg?updatedAt=1714491501386",
    caseStudy: {
      link:
        "https://imagekit.io/blog/bookmyshow-case-study/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/BMSGraphic@3x.webp?updatedAt=1714491389351",
      excerpt:
        "BookMyShow achieved significant cost savings while improving loading speed & video file sizes.",
      highlight: "30% faster load time, 60% smaller videos",
    },
    testimonials: [
      {
        text:
          "With ImageKit, we have saved more than half the cost we incurred earlier. Further, it allowed us to leverage next-gen image formats, drastically improving our web and app performance across all platforms.",
        author: "Vaibhav Jain",
        authorTitle: "Engineering Manager, BookMyShow",
        authorPic:
          "https://ik.imagekit.io/ikmedia/vaibhav-jain-bookmyshow?tr=w-80",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.LENSKART,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Lenskart_120_45_hid-CswV4.png",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Lenskart%20Logo%20white@3x.webp?updatedAt=1714490988970",
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/lenskart_hfp3Mzdup.png",
    caseStudy: {
      link:
        "https://imagekit.io/blog/how-lenskart-improved-conversion-and-global-expansion-using-better-visual-experience/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/Lenskart.webp?updatedAt=1714495310171",
      excerpt:
        "Lenskart leveraged better visual experience to improve conversion and global expansion",
      highlight: "Leveraged better visual experience to improve conversion",
    },
  },
  {
    name: CUSTOMER_ENUM.NYKAA,
    logo: "https://ik.imgkit.net/ikmedia/nykaa-logo_pOBWO_gI3.svg",
    whiteLogo : "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Nykaa.svg?updatedAt=1714488684832",
    themeGradient: ["rgb(253 38 121 / 96%)", "rgb(255 226 227 / 79%)"],
    circularLogo:
      "https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/nykaa_GArTlMC7IT.png",
    caseStudy: {
      link:
        "https://imagekit.io/blog/nykaa-image-management-optimization-imagekit-case-study/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/Nykaa.webp?updatedAt=1714495435328",
      excerpt:
        "Nykaa simplified image management and optimization for their websites and apps.",
      highlight: "Simplified image optimization",
    },
    testimonials: [
      {
        text:
          "ImageKit allows us to deliver optimized images across web and mobile with minimal effort. We don't have to think much about compressing the images to the right size or delivering it in the right format. And it has made life simpler for our developers.",
        author: "Sanjay Suri",
        authorTitle: "CTO, Nykaa.com",
        authorPic:
          "https://ik.imgkit.net/ikmedia/sanjay_suri_AzIfFUrReP.png?tr=w-80",
      },
      {
        excerpt: "Our customers get actionable advice from actual engineers.",
        text:
          "ImageKit team has been really helpful with their support or even if we have some doubts. Their team is just a call away and they are able to explain things very well and resolve all our queries in just a few hours.",
        author: "Ankit Pandey",
        authorTitle: "Lead Engineer, Nykaa.com",
        authorPic: "",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.WELTBILD,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/Weltbild_35UAV1_zCJ.png",
    whiteLogo : "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Weltbild%20White@3x.webp?updatedAt=1714490988955",
    hideLogo: true,
    circularLogo:
      "https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/weltbild_yai8fPaRo.png",
    caseStudy: {
      link:
        "https://imagekit.io/blog/weltbild-architecture-high-quality-images-imagekit/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/Weltbild.webp?updatedAt=1714495310186",
      excerpt:
        "Weltbild switched to a modular, high-quality image delivery architecture while reducing costs.",
      highlight: "Modular media delivery architecture",
    },
    testimonials: [
      {
        text:
          "ImageKit media processing is integrated with our CDN and storage. It has worked great for us until now, and I don't need to go back to their dashboard because the service works! We tried throwing different kinds of images at ImageKit, and ImageKit would consistently deliver the correct output format.",
        author: "Hubert Ried",
        authorTitle: "SEO Consultant",
        authorPic:
          "https://ik.imgkit.net/ikmedia/Hubert_Ried_zSvQGnSvN.png?tr=w-80",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.CURTSY,
    logo: "https://ik.imagekit.io/ikmedia/website-2024/customers/cursty.svg?updatedAt=1710245762935",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Curtsy%20Logo@3x.webp?updatedAt=1714490988630",
    caseStudy: {
      link:
        "https://imagekit.io/blog/improving-customer-engagement-and-transactions-with-personalized-banners-curtsy-case-study/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/Curtsy.webp?updatedAt=1714495435335",
      excerpt:
        "Curtsy improved customer engagement and transactions with personalized banners",
      highlight: "Improved customer engagement with personalized banners",
    }
  },
  {
    name: CUSTOMER_ENUM.LEROY,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Leroy_Merlin.svg",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Leroy.svg?updatedAt=1714488684878",
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/Leroy_Merlin.png",
  },
  {
    name: CUSTOMER_ENUM.DUBREUIL,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Dubreuil%20(1).svg?updatedAt=1714488936509",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Dubreuil.svg?updatedAt=1714488684856"
  },
  {
    name: CUSTOMER_ENUM.TRAVELOKA,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/traveloka_tKBPqER5UW.svg",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/Traveloka.svg?updatedAt=1714488684974",
    circularLogo:
      "https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/traveloka_VgOOP2zXHm.png",
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.JAMIE_OLIVER,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/jo_8wfps1NVUi.png",
    hideLogo: true,
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/JamieOliver.svg?updatedAt=1714488684898",
    circularLogo:
      "https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/jamieoliver_jA1psQm2sR.png",
  },
  {
    name: CUSTOMER_ENUM.DUNZO,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/Dunzo_ziTNkAbbwr.svg",
    hideLogo: true,
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/Dunzo_F9y6g9TkN.png",
  },
  {
    name: CUSTOMER_ENUM.UPGRAD,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/upgrad_unBUjAeLG.png",
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/upgrad_SY0uMsnzwNpr.png",
  },
  {
    name: CUSTOMER_ENUM.ZEPTO,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Zepto.svg",
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/zepto.png",
  },
  {
    name: CUSTOMER_ENUM.EIGHT_X_EIGHT,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/8x8-Logo_864KXAta6W.png",
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/8x8_lwb294tl5.png",
    logoWidth: 90,
  },
  {
    name: CUSTOMER_ENUM.MOENGAGE,
    logo: 'https://ik.imgkit.net/ikmedia/website-assets/moengage_logo_QFfoHD13-.svg'
  },
  {
    name: CUSTOMER_ENUM.HOPSCOTCH,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/hopscotch__pVzW02Odq.png",
    whiteLogo : "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/hopscotch.png?updatedAt=1721053050063",
    caseStudy: {
      link:
        "https://imagekit.io/blog/how-hopscotch-built-indias-largest-online-kids-fashion-brand-with-imagekit/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/Graphics/Blog_Covers/Hopscotch_customers.jpg?updatedAt=1721053294018&tr=w-400,dpr-2",
      excerpt:
        "Hopscotch simplified media processing workflows, improved visual quality, and achieved 30% faster load times with ImageKit.",
      highlight: "Improved visual quality and 30%+ faster app load times",
    },
  },
  {
    name: CUSTOMER_ENUM.KOO,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Koo_zavup-LEM.png",
    hideLogo: true,
    circularLogo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/circular_logos/Koo_V7zw-wZI_xM0.png",
    hideCircularLogo: true
  },
  {
    name: CUSTOMER_ENUM.NINETY_ONE_MOBILE,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/91mobiles_rjB017fHG.png",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/91Mobiles%20logo@3x.webp?updatedAt=1714490988584",
    caseStudy: {
      link:
        "https://imagekit.io/blog/91mobiles-image-optimization-imagekit-case-study/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/91Mobiles3x.webp?updatedAt=1714495435560",
      excerpt:
        "91Mobiles ensures super-fast delivery of high-resolution gadget images to its visitors.",
      highlight: "35% reduction in bandwidth usage",
    },
    testimonials: [
      {
        text:
          "Effortlessly switched from our in-house image resizing solution to ImageKit. It helped make our web pages load faster on different devices and simplified our image workflow. It also helped us reduce infrastructure cost!",
        author: "Bharanidharan Viswanathan",
        authorTitle: "CEO, 91mobiles.com",
        authorPic:
          "https://ik.imgkit.net/ikmedia/Bharanidharan_Viswanathan_Yi2XVFd32.png?tr=w-80",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.CARS_CO_ZA,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/carscoza_XqGKncEDz_.png",
  },
  {
    name: CUSTOMER_ENUM.SINTRA_CONSULTING,
    hideLogo: true,
    hideCircularLogo: true,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/si_H6ufzVV5BE.png",
    caseStudy: {
      link:
        "https://imagekit.io/blog/sintra-digital-business-improved-page-size-using-imagekit/",
      coverImage:
        "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/Sintra_cs-cover_JB2MpiOaGS.png",
      excerpt:
        "Sintra Digital Business delivers lighter and faster pages on its clients' websites.",
      highlight: "33% page size reduction",
      hide: false,
    }
  },
  {
    name: CUSTOMER_ENUM.PURPLLE_COM,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/purplle-logo-1_MWQvpjmjy.svg",
    whiteLogo : "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/purplle%20logo@3x.webp?updatedAt=1714490988503",
    caseStudy: {
      link:
        "https://imagekit.io/blog/purplle-image-optimization-imagekit-case-study-new/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/Purplle.webp?updatedAt=1714495435495",
      excerpt:
        "Purplle.com cut down its image bandwidth consumption by about 60% using ImageKit.",
      highlight: "Improved web performance",
    },
    testimonials: [
      {
        text:
          "ImageKit has made real-time image manipulation, optimization and resizing across devices really easy. It’s an out of the box plug & play offering with minimal changes in existing infrastructure. And yes, your images stay where they are!",
        author: "Suyash Katyayani",
        authorTitle: "CTO, Purplle",
        authorPic:
          "https://ik.imgkit.net/ikmedia/Suyash_Katyayani_Gh0IVxPHDP.png?tr=w-80",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.THE_LOOM,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/the-loom_VFcOgYBjn.svg",
    circularLogo:
      "https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/theeloom_tUq62TCh_K.png",
    hideCircularLogo: true,
    testimonials: [
      {
        excerpt:
          "The Loom solved the image quality problem with Magento while reducing page weight.",
        text:
          "We migrated to ImageKit after a month long deliberation and don't regret it one bit. It has helped improve our page load times by drastically reducing the image size. More importantly, the images look much better than the default Magento compression.",
        author: "Komal Goel",
        authorTitle: "Founder, The Loom",
        authorPic: "",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.ZIVAME,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/zivame-logo_waSDprFC_.png",
  },
  {
    name: CUSTOMER_ENUM.JAYPORE,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/jaypore_logo_retina_pA3dDgGYG.png",
    hideLogo: true,
  },
  {
    name: CUSTOMER_ENUM.VENTIS,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/ventis_XebDAjK9GC.png",
    hideLogo: true,
    testimonials: [
      {
        text:
          "My company decided to switch from another image optimization product and use Imagekit.io in order to use S3 as image storage. It was great because the migration was very simple. The pricing is competitive and the support is great!",
        author: "Daniele Puccio Tiraferri",
        authorTitle: "IT manager, Ventis S.R.L",
        authorPic: "",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.UTSAV_FASHION,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/utsavfashion-logo_8ilfjvHX2.png",
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.MIAMI,
    logo: 'https://ik.imgkit.net/ikmedia/website-assets/logo-gmcvb-corp_-XlZvPg47.svg',
    circularLogo: 'https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/miami_X9_G0hYYe.png',
    hideLogo: true,
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.SPINE_MEDIA,
    logo:
      "https://ik.imgkit.net/ikmedia/website-assets/customer-logo/spine-media_jnJ0qgaCV.png",
    whiteLogo: "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/white/SpineMedia%20Logo@3x.webp?updatedAt=1714490988544",
    caseStudy: {
      link:
        "https://imagekit.io/blog/spine-media-optimized-images-pageload-imagekit/",
      coverImage:
        "https://ik.imagekit.io/ikmedia/website-2024/customers/SpineMedia.webp?updatedAt=1714495435495",
      excerpt:
        "Spine Media optimized content creation & page load time with smart crop & image transformations.",
      highlight: "Optimized image workflows and turnaround time",
    },
  },
  {
    name: CUSTOMER_ENUM.DURIAN,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/durian_fAOHuDHnq.png",
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.SONY,
    logo: 'https://ik.imgkit.net/ikmedia/website-assets/customer-logo/sony_79pB4q1R8.png',
    circularLogo: 'https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/sony_VxeiMR_Kj2.png',
    hideLogo: true,
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.STANDARD_NEWS,
    logo: 'https://ik.imgkit.net/ikmedia/website-assets/customer-logo/sn_u6UlXewD8.png',
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.HYRECAR,
    logo: 'https://ik.imgkit.net/ikmedia/website-assets/customer-logo/hyrecar_m1AbpDzss9.svg',
    circularLogo: 'https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/hyrecar_KAHpmfcv4q.png',
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.ASIAN_PAINTS,
    logo: 'https://ik.imgkit.net/ikmedia/website-assets/customer-logo/AsianPaints_6OO9BbdXtK.svg',
    circularLogo: 'https://ik.imgkit.net/ikmedia/site_graphics/circular_logos/asian_paints_5EOaOKONEw.png',
    hideLogo: true,
    hideCircularLogo: true,
  },
  {
    name: CUSTOMER_ENUM.APPSTEM,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/ic-appstem-logo@2x.png?updatedAt=1720070194145",
    caseStudy: {
      highlight: "A must-have for any modern project!",
    },
    testimonials: [
      {
        text:
          "ImageKit has changed the game with fast and reliable video and image delivery! The intelligent transcoding and compression algorithms optimize media delivery across all devices, allowing us to focus on building our products. Exceptional support and seamless integration make it a must-have for any modern project!",
        author: "Robert Armstrong",
        authorTitle: "CEO, Appstem",
        authorPic:
          "https://ik.imagekit.io/ikmedia/Robert_Appstem.jpg?updatedAt=1720067771595&tr=w-80",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.ETREX,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/etrex_logo.svg",
    caseStudy: {
      highlight: "Optimizing images has never been easier",
    },
    testimonials: [
      {
        text:
          "Images are a crucial part of any good website design. With different device sizes and screen aspect ratios, it can be time-consuming to prepare images in all the necessary dimensions. That's why our customers are always delighted to hear how we've automated this process for them with ImageKit. As a result, it has become one of our agency's standard tools for all web development projects.",
        author: "Patrik Fluck",
        authorTitle: "CEO, Etrex",
        authorPic:
          "https://ik.imagekit.io/ikmedia/Robert_Appstem.jpg?updatedAt=1720067771595&tr=w-80",
      },
    ],
  },
  {
    name: CUSTOMER_ENUM.SECRETLAB,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/SecretLab.png"
  },
  {
    name: CUSTOMER_ENUM.CROMA,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Croma.svg"
  },
  {
    name: CUSTOMER_ENUM.STAMPED,
    logo:
      "https://ik.imagekit.io/ikmedia/site_graphics/customers/logos/Stamped.svg"
  },
  {
    name: CUSTOMER_ENUM.AUCIO,
    logo:
      "https://ik.imagekit.io/ikmedia/Website%20Revamp/Logos/Partner%20Logos/Aucio_logo.svg"
  },
  {
    name: CUSTOMER_ENUM.SEVENTYTWO,
    logo:
      "https://ik.imagekit.io/ikmedia/Website%20Revamp/Logos/Partner%20Logos/seventytwo_logo.svg"
  },
  {
    name: CUSTOMER_ENUM.LIMELY,
    logo:
      "https://ik.imagekit.io/ikmedia/Website%20Revamp/Logos/Partner%20Logos/Limely_logo.svg"
  },
  {
    name: CUSTOMER_ENUM.FOCALWORKS,
    logo:
      "https://ik.imagekit.io/ikmedia/Website%20Revamp/Logos/Partner%20Logos/focalworks_logo.svg"
  }
];

export const DAM_CUSTOMERS = [
  CUSTOMER_ENUM.NYKAA,
  CUSTOMER_ENUM.CRED,
  CUSTOMER_ENUM.LEROY,
  CUSTOMER_ENUM.UPGRAD,
  CUSTOMER_ENUM.CROMA,
  CUSTOMER_ENUM.TRAVELOKA
];

export const MEDIA_PROCESSING_CUSTOMERS = [
  CUSTOMER_ENUM.SWIGGY,
  CUSTOMER_ENUM.STAMPED,
  CUSTOMER_ENUM.LEROY,
  CUSTOMER_ENUM.CRED,
  CUSTOMER_ENUM.BOOKMYSHOW,
  CUSTOMER_ENUM.TRAVELOKA
];

export const AGENCY_CUSTOMERS = [
  CUSTOMER_ENUM.ETREX,
  CUSTOMER_ENUM.APPSTEM,
  CUSTOMER_ENUM.LIMELY,
  CUSTOMER_ENUM.FOCALWORKS,
  CUSTOMER_ENUM.SEVENTYTWO,
  CUSTOMER_ENUM.AUCIO
]

export const NEWS_MEDIA_CUSTOMERS = [
  CUSTOMER_ENUM.SPINE_MEDIA,
  CUSTOMER_ENUM.HYRECAR,
  CUSTOMER_ENUM.CRED,
  CUSTOMER_ENUM.BOOKMYSHOW,
  CUSTOMER_ENUM.NINETY_ONE_MOBILE,
  CUSTOMER_ENUM.UPGRAD
]

export const TRAVEL_CUSTOMERS = [
  CUSTOMER_ENUM.TRAVELOKA,
  CUSTOMER_ENUM.HYRECAR,
  CUSTOMER_ENUM.SAFFRON_STAYS,
  CUSTOMER_ENUM.CARS_CO_ZA,
  CUSTOMER_ENUM.BOOKMYSHOW,
  CUSTOMER_ENUM.UPGRAD
]